import {
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { NewInputText } from "../../reusableComponents/inputReusableComponent/InputBoxComponent";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";

import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";

function AddStaff(props) {
  return (
    <React.Fragment>
      <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation />
            <Container>
              <div className="f20-700">Add Staff</div>
              <Row className="mt-4">
                <Col md={4}>
                  <NewInputText labelText="Role Name" />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col md={4}>
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel id="demo-simple-select-outlined-label">
                      Select Role
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      // value={age}
                      // onChange={handleChange}
                      label="Select Role"
                    >
                      <MenuItem value="">role</MenuItem>
                    </Select>
                  </FormControl>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col md={6}>
                  <NewInputText labelText="Location ID" />
                </Col>
              </Row>
              location
              <Row className="mt-4">
                <Col md={6}>
                  <NewInputText labelText="First Name" />
                </Col>
                <Col md={6}>
                  <NewInputText labelText="Last Name" />
                </Col>
                <Col md={6}>
                  <NewInputText labelText="Email Address" />
                </Col>
                <Col md={6}>
                  <NewInputText labelText="Password" />
                </Col>
                <Col md={6}>
                  <Row>
                    <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                      <Form.Group
                        // className="reusableInputComponent-main mb-0"
                        controlId={"code"}
                      >
                        <div className="input-phone-country-code-reusable w-100">
                          <select
                            name="code"
                            //   value={state.code}
                            //   onChange={onChange}
                            className="w-100"
                          >
                            {/* <option value={state.code}>{state.code}</option> */}
                            {getCountries().map((country) => (
                              <option
                                key={country}
                                value={"+" + getCountryCallingCode(country)}
                              >
                                {en[country]} (+{getCountryCallingCode(country)}
                                )
                              </option>
                            ))}
                          </select>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col xs={8}>
                      <Form.Group>
                        <TextField
                          id="mobile_number"
                          label="Phone Number"
                          type="number"
                          variant="outlined"
                          fullWidth
                          onInput={(e) => {
                            e.target.value = Math.max(
                              0,
                              parseInt(e.target.value)
                            )
                              .toString()
                              .slice(0, 10);
                          }}
                          name="mobile_number"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <hr />
              <div className="f18-500">Contact Details</div>
              <Row className="mt-4">
                <Col md={6}>
                  <NewInputText labelText="Address Line 1" />
                </Col>
                <Col md={6}>
                  <NewInputText labelText="Address Line 2" />
                </Col>
                <Col md={6}>
                  <NewInputText labelText="State" />
                </Col>
                <Col md={6}>
                  <NewInputText labelText="City" />
                </Col>
                <Col md={6}>
                  <NewInputText labelText="Country" />
                </Col>
                <Col md={6}>
                  <NewInputText labelText="Zipcode" />
                </Col>
                <Col md={6}>
                  <NewInputText labelText="Alternate Phone Number" />
                </Col>
              </Row>
              <hr />
              <div className="f18-500">Verified?</div>
              <Row>
                <Col md={4}>
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel id="demo-simple-select-outlined-label">
                      Select Status
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      // value={age}
                      // onChange={handleChange}
                      label="Select Status"
                    >
                      <MenuItem value="">status</MenuItem>
                    </Select>
                  </FormControl>
                </Col>
              </Row>
              <div>
                <div class="d-flex align-items-center py-4">
                  <button
                    type="button"
                    class="btn-md mr-4 px-5 btn btn-outline-secondary"
                  >
                    Cancel
                  </button>
                  <button type="button" class="btn-md px-5 btn btn-danger">
                    Add
                  </button>
                </div>
              </div>
            </Container>
          </div>
        </Row>
      </div>
    </React.Fragment>
  );
}

export default AddStaff;
